import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import '../css/estilos.css'; 
import ciencia from '../img/01-ciencia.jpg';
import ingenieriaX from '../img/01-ingenieria.jpg';
import cancer from '../img/02-cancer.jpg';
import piscis from '../img/02-piscis.jpg';
import cruz from '../img/03-cruz-azul.jpg';
import pumas from '../img/03-pumas.jpg';
import tlalpan from '../img/04-Tlalpan.jpg';
import mhidalgo from '../img/04-Miguel-Hidalgo.jpg';
import siga from '../img/05-se-queda.jpg';
import vaya from '../img/05-se-va.jpg';
import cuartel from '../img/06-afuera.jpg';
import ejercito from '../img/06-regreso.jpg';
import carcel from '../img/07-carcel-desproposito.jpg';
import tribu from '../img/07-carcel-terror.jpg';
import cdmx from '../img/08-cdmx.jpg';
import yuca from '../img/08-merida.jpg';
import suprem from '../img/09-corte-voto.jpg';
import voto from '../img/09-ministros-corte.jpg';
import no from '../img/10-firma-obvio-no.jpg';
import pacto from '../img/10-firma-sangre.jpg';
import Claudia from './claudia';
import Xochitl from './Xochitl';

const Quiz = ({ onQuizComplete }) => {
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [answers, setAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [userId, setUserId] = useState('');

  useEffect(() => {
    // Comprobamos si ya tenemos un userId almacenado en el localStorage
    const storedUserId = localStorage.getItem('userId');
    if (storedUserId) {
      setUserId(storedUserId);
    } else {
      // Si no hay un userId almacenado, generamos uno nuevo y lo guardamos
      const newUserId = 'user' + Math.floor(Math.random() * 1000000); // Generamos un número aleatorio para el userId
      setUserId(newUserId);
      localStorage.setItem('userId', newUserId);
    }
  
    const storedAnswers = localStorage.getItem('quizAnswers');
    if (storedAnswers) {
      const parsedAnswers = JSON.parse(storedAnswers);
      setAnswers(parsedAnswers);
      const lastQuestion = Object.keys(parsedAnswers).length;
      setCurrentQuestion(lastQuestion + 1);
      setQuizCompleted(lastQuestion >= 10); // Actualiza el estado de quizCompleted según si se han respondido todas las preguntas
      if (lastQuestion >= 10) {
        setShowResults(true); // Muestra los resultados si se han respondido todas las preguntas
      }
    }
  }, []);
  
 
  const handleAnswer = (option) => {
    if (!answers[currentQuestion]) {
      // Obtener el ID de la pregunta actual del estado local
      const questionID = [
        1711398547,
        1711399307,
        1711477750,
        1711479798,
        1711479911,
        1711479980,
        1711480039,
        1711480095,
        1711480159,
        1711480300
      ][currentQuestion - 1];
  
      // Obtener el target de la opción seleccionada
      const target = option.target.toString();
  
      // Crear el objeto directamente en el cuerpo de la solicitud POST
      const bodyData = JSON.stringify({
        idpregunta: questionID.toString(),
        respuestau: option.text.toString(),
        useranswer: userId
      });
  
      // Actualizar las respuestas en el estado local
      const updatedAnswers = { ...answers, [currentQuestion]: { bodyData, target } };
      setAnswers(updatedAnswers);
      localStorage.setItem("quizAnswers", JSON.stringify(updatedAnswers));
  
      setCurrentQuestion(currentQuestion + 1);
      if (currentQuestion >= 10) {
        setShowResults(true);
        setQuizCompleted(true);
        onQuizComplete();
      }
  
      // Realizar la solicitud POST a la API
      fetch("https://zmp55fgimf.execute-api.us-east-2.amazonaws.com/prod/respuestas", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodyData,
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error al enviar el dato: " + response.statusText);
        }
       console.log("¡Petición realizada con éxito!"); 
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    }
  };
  
  const calculateResult = (answers) => {
    let claudiaPoints = 0;
    let xochitlPoints = 0;
  
    for (const answer of Object.values(answers)) {
      const target = answer.target; // Obtenemos el target directamente
      if (target === "Claudia") {
 
        claudiaPoints += 1; // Asumiendo que cada respuesta tiene un peso de 1, puedes ajustar esto según sea necesario
      } else if (target === "xochitl") {
  
        xochitlPoints += 1; // Asumiendo que cada respuesta tiene un peso de 1, puedes ajustar esto según sea necesario
      }
    }

    return claudiaPoints > xochitlPoints ? <Claudia /> : <Xochitl />;
  };
  
  
  
  


  const renderQuestion = () => {
    const questions = [
      {
        title: "Empecemos con algo sencillo, ¿si tuvieras que elegir entre estas dos carreras, cuál escogerías?",
        options: [
          { text: "A) Ciencias", image: ciencia, target: "Claudia", weight: 1 },
          { text: "B) Ingeniería", image: ingenieriaX, target: "xochitl", weight: 1 }
        ]
      },
      {
        title: "Sigamos con las cosas ligeras. Digamos que puedes escoger tu signo zodiacal, ¿cuál sería?",
        options: [
          { text: "A) Piscis", image: piscis, target: "xochitl", weight: 1 },
          { text: "B) Cáncer", image: cancer, target: "Claudia", weight: 1 }
        ]
      },
      {
        title: "Vamos con lo más importante de lo menos importante. ¿Qué equipo es el bueno?",
        options: [
          { text: "A) Cruz Azul", image: cruz, target: "xochitl", weight: 1 },
          { text: "B) Pumas", image: pumas, target: "Claudia", weight: 1 }
        ]
      },
      {
        title: "Vamos con algo más serio. Si pudieras elegir una alcaldía para gobernar, ¿cuál sería?",
        options: [
          { text: "A) Miguel Hidalgo", image: mhidalgo, target: "xochitl", weight: 1 },
          { text: "B) Tlalpan", image: tlalpan, target: "Claudia", weight: 1 }
        ]
      },
      {
        title: "Ya en materia sobre propuestas de gobierno… ¿Que siga la 4T o que se vaya?",
        options: [
          { text: "A) Que siga", image: siga, target: "Claudia", weight: 1  },
          { text: "B) Que se vaya", image: vaya, target: "xochitl", weight: 1 }
        ]
      },
      {
        title: "El Ejército es un tema controversial, tu opinión es que:",
        options: [
          { text: "A) Que siga en las calles", image: cuartel, target: "Claudia", weight: 1 },
          { text: "B) Que regrese a los cuarteles", image: ejercito, target: "xochitl", weight: 1 }
        ]
      },
      {
        title: "La idea de una cárcel que cause terror a los criminales te parece:",
        options: [
          { text: "A) Vale la pena intentarlo", image: tribu, target: "xochitl", weight: 2},
          { text: "B) Un despropósito", image: carcel ,target: "Claudia", weight: 2 }
        ]
      },
      {
        title: "¿Qué estado te parece modelo en combate al crimen?",
        options: [
          { text: "A) CDMX", image: cdmx, target: "Claudia", weight: 1 },
          { text: "B) Yucatán", image: yuca, target: "xochitl", weight: 1  }
        ]
      },
      {
        title: "Los jueces y ministros de la Suprema Corte ¿deben ser elegidos por el pueblo?",
        options: [
          { text: "A) No estaría mal que se sometan a la voluntad popular", image: suprem, target: "Claudia", weight: 2},
          { text: "B) Se elegirán a los mejores, no a los más populares", image: voto,target: "xochitl", weight: 2 }
        ]
      },
      {
        title: "Ya el pilón, ¿te animas a firmar con sangre un pacto?",
        options: [
          { text: "A) Obvio no", image: no, target: "Claudia", weight: 1},
          { text: "B) Si hace falta, cómo no", image: pacto, target: "xochitl", weight: 1 }
        ]
      },
    ];

    

    const currentQuestionData = questions[currentQuestion - 1];

    
    

    return (
      <div className="main-quiz">
        <div className="pregunta">
          <p className="p-numero">{currentQuestion}</p>
          <p className="p-titulo">{currentQuestionData.title}</p>
        </div>
  
        <div className="respuestas">
          {currentQuestionData.options.map((option, index) => (
            <div className="formato-respuesta" key={index} onClick={() => handleAnswer(option)}>
              <div className="fondo-imagen">
                <img className="t-imagen" src={option.image} alt={option.text} />
              </div>
              <p className="t-opciones">{option.text}</p>
            </div>
          ))}
        </div>
  
        <div className="div-barra">
          <div className="f-barra">
            <div className="b-progreso" style={{ width: `${(currentQuestion / questions.length) * 100}%` }}></div>
          </div>
        </div>
      </div>
    );
  };

  const restartQuiz = () => {
    localStorage.removeItem("quizAnswers");
    localStorage.removeItem("showHeader");
    window.location.reload();
  };
  
  return (
    <>
      {!quizCompleted && currentQuestion <= 10 ? (
        <div className="main-quiz">
          {renderQuestion()}
        </div>
      ) : (
        <div>
          {showResults && (
            <div>
              {/* Mostrar resultados */}
              {calculateResult(answers)}
              {/* Botón para reiniciar */}
              <div className="boton-centro">
                <p className="repetir-quiz">¿Crees que te pareces a la otra candidata?<br/>Averigua si tienes razón</p>
                <button className="boton-quiz">
                  <div className="t-boton" onClick={restartQuiz}>¡Vuelve a tomar el quiz!</div>
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
  
};

Quiz.propTypes = {
  onQuizComplete: PropTypes.func.isRequired, // PropType para la función de devolución de llamada
};

export default Quiz;
